<template>
  <div>
    <g-title
      title="订单明细"
      class="c-p-20"
    ></g-title>
    <g-img-list :faImg="goodsInfo.imgUrl"></g-img-list>
    <div class="c-fl-bt c-p-20">
      <div class="l-txt">活动优惠</div>
      <div class="r-txt">无优惠</div>
    </div>
    <div class="c-fl-bt btm">
      <div class="b-l">
        <span>合计:</span>
        <span>￥{{goodsInfo.price}}</span>
      </div>
      <div
        class="immediately-pay c-f-ar"
        @click="immediatelyPay"
      >立即支付</div>
    </div>
  </div>
</template>

<script>
import { submitOrder, getOrderDetail } from '@/api/order'
export default {
  name: "SaleConfirmMenu",
  props: {

  },
  data() {
    return {
      goodsInfo: {},
      userPhone: $pub.getS('userPhone'),
      sequenceId: null,
      orderDetails: [],
      amount: null,
      originalAmount: null,
    };
  },
  created() {
    this.goodsInfo = this.$pub.getS('goodsInfo');

  },
  mounted() {

  },
  methods: {
    async immediatelyPay() {
      const requestParams = {
        Items: [
          {
            DistributorId: localStorage.getItem('distributorId'),
            ProductId: this.goodsInfo.id,
            Quantity: this.goodsInfo.number,
          }
        ],
        Phone: this.userPhone,
        VpnId: this.$store.state.vpnId,
      };
      const orderId = await submitOrder(requestParams);
      const orders = await getOrderDetail({ query: { id: orderId } });
      const order = orders.Items[0]
      this.sequenceId = order.SequenceId
      this.orderDetails = order.Details
      this.amount = order.Receipts;
      this.originalAmount = order.Receipts;
    }
  }
};
</script>
<style scoped lang='scss'>
.btm {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: 100%;
  .b-l {
    margin-left: 20px;
  }
  .immediately-pay {
    color: #fff;
    background: var(--tc);
    width: 200px;
    height: 100%;
    /* display: flex;
    align-items: center;
    justify-content: space-around; */
  }
  .l-txt {
    font-size: 24px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #888888;
  }
  .r-txt {
    font-size: 24px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #333333;
  }
}
</style>
